'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseReportController = require('../baseReportController');

var _baseReportController2 = _interopRequireDefault(_baseReportController);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TestDrivesController = function (_BaseReportController) {
  (0, _inherits3.default)(TestDrivesController, _BaseReportController);

  function TestDrivesController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, TestDrivesController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TestDrivesController.__proto__ || (0, _getPrototypeOf2.default)(TestDrivesController)).call(this, reportingService, loadingService, utilsService));

    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
      return (0, _possibleConstructorReturn3.default)(_this);
    }

    _this.authService = authService;
    _this.reportingService = reportingService;
    _this.userService = userService;
    _this.enums = enums;
    _this.loadingService = loadingService;
    _this.lookupService = lookupService;
    _this.$q = $q;
    _this.$scope = $scope;
    _this.printService = printService;
    _this.exportService = exportService;
    _this.utilsService = utilsService;

    _this.reportCriteria = {};
    _this.dtPopups = {};
    _this.errMsgs = [];

    _this.panels = {
      reportCriteria: true,
      reportSummary: false,
      reportData: false
    };

    _this.summary = [];

    _this.initializeLookups().then(function () {
      _this.getUserLocations();
      _this.getDateRangeList();
      _this.reset();
    });
    return _this;
  }

  (0, _createClass3.default)(TestDrivesController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this2 = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        brands.splice(0, 1);
        brands.unshift({ id: null, name: 'All' });
        _this2.brands = brands;

        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
          _this2.allBrandModels = brandModels;
          deferred.resolve();
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getDateRangeList',
    value: function getDateRangeList() {
      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(fieldName) {
      this.dtPopups[fieldName] = true;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.$broadcast('reports:reset');

      this.summary = [];

      this.errMsgs = [];

      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
      this.reportCriteria.startDate = new Date();
      this.reportCriteria.endDate = new Date();
      this.reportCriteria.location = this.userLocations[0];
      this.reportCriteria.brand = this.brands[0];

      this.updateUserList();
      this.updateBrandModel();
    }
  }, {
    key: 'updateUserList',
    value: function updateUserList() {
      var _this3 = this;

      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');

      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
        _this3.userList = response.data.map(function (i) {
          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
        });
        _this3.userList.unshift({ id: null, name: 'All' });

        _this3.reportCriteria.user = _this3.userList[0];
      }).finally(function () {
        _this3.loadingService.hideLoading('reportCriteria');
      });
    }
  }, {
    key: 'runReport',
    value: function runReport() {
      this.panels.reportData = true;

      this.$scope.$broadcast('reports:runReport', {
        action: 'testDrives',
        criteriaValidator: this.validateCriteria.bind(this),
        criteriaParser: this.parseCriteria.bind(this)
      });
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      this.errMsgs = [];

      if (!this.reportCriteria.startDate) {
        this.errMsgs.push('Please provide a Start Date');
      }

      if (!this.reportCriteria.endDate) {
        this.errMsgs.push('Please provide an End Date');
      }

      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
        this.errMsgs.push('Start Date can not be greater than End Date');
      }

      return this.errMsgs.length === 0;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      this.parseStartAndEndDate(parsedCriteria);

      parsedCriteria.locationIds = this.getLocationIds();
      parsedCriteria.salesRepId = this.reportCriteria.user.id;
      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;

      return parsedCriteria;
    }
  }, {
    key: 'getLocationIds',
    value: function getLocationIds() {
      var locationIds = void 0;

      if (!this.reportCriteria.location.id) {
        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
          return o.id;
        }).map(function (ul) {
          return ul.id;
        });
      } else {
        locationIds = [this.reportCriteria.location.id];
      }

      return locationIds;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this4 = this;

      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === _this4.reportCriteria.brand.brandId;
      });
      this.brandModels.unshift({ id: null, name: 'All' });
      this.reportCriteria.brandModel = this.brandModels[0];
    }
  }, {
    key: 'onReportRun',
    value: function onReportRun(summary) {
      this.summary = summary;
    }
  }, {
    key: 'printReport',
    value: function printReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.printService.printReport('Test Drives', this.parseCriteria());
    }
  }, {
    key: 'exportReport',
    value: function exportReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.exportService.exportReport('Test Drives', this.parseCriteria());
    }
  }]);
  return TestDrivesController;
}(_baseReportController2.default);

exports.default = TestDrivesController;


// WEBPACK FOOTER //
// ./client/app/components/reports/testDrives/testDrives.controller.js